import { useEffect } from 'react';

import HomeBarButton from '@core/dashboard/components/HomeBarButton';
import { useAssistant } from '@core/assistant/providers/Provider';
import { VirtualAssistantIcon } from './VirtualAssistantIcon';
import { useStyles } from './styles';
import { log } from '../providers/Debug';

const Button = ({ isLargeButton }: { isLargeButton?: boolean }) => {
  const { setOpen, startFlow, scripts } = useAssistant();
  const classes = useStyles(isLargeButton);

  useEffect(() => {
    log('scripts', scripts);

    if (!scripts?.length) {
      return;
    }

    setTimeout(() => {
      setOpen(true);
    }, 0);
    startFlow('landing');
  }, [scripts]);

  return (
    <HomeBarButton
      sx={classes.homeBarButton}
      label={'Noa Assistant'}
      icon={<VirtualAssistantIcon isLargeButton={isLargeButton} />}
      handleClick={() => {
        setOpen((prevState) => !prevState);
      }}
    />
  );
};

export default Button;
